<!-- 销售结算申请 -->
<template>
  <div class='page_content'>
    <subComponents ref="showSelectData"></subComponents>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearchs="openSearch"></v-search>

      </div>
    </div>
    <div class="page_content_center">
      <el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" @selection-change="handleSelectionChange" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
        <el-table-column type="selection" width="40">
        </el-table-column>
        <el-table-column v-if="tableValye.isShow == 1" align="center" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
          :prop="tableValye.entityField" :label="tableValye.showField">
          <template slot-scope="scope">
            <span v-if="tableValye.entityField == 'psomState'">
              {{ $store.state.purchaseOrderState[scope.row[tableValye.entityField]].name }}
            </span>
            <el-tag size="mini" v-else-if="tableValye.entityField == 'psomIswmsm'">
              {{ scope.row.psomIswmsm == 0 ? '否' : '是' }}
            </el-tag>
            <span v-else-if="tableValye.entityField == 'settleMode' || tableValye.entityField == 'dsapmState'">
              <span v-for="(item, i) in JSON.parse(tableValye.formatterContent)" :key="i">
                <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">{{
                                            item.value }}
                </el-tag>
              </span>
            </span>
            <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">
              {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
            <span v-else-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
              </span>
            </span>
            <span v-else-if="tableValye.fieldType == 'dateTime'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField],true) }}
              </span>
            </span>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                        scope.row[tableValye.entityField] }}</a>
            </span>
            <span v-else-if="tableValye.entityField == 'createTime'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
              </span>
            </span>
            <span v-else>
              {{ scope.row[tableValye.entityField] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <el-dialog title="记账" v-if="bookKeepShow" :visible.sync="bookKeepShow" width="60%">
      <div>
        <el-form @submit.native.prevent inline :model="sendDataInfo" ref="sendDataInfo" class="demo-form-inline" size="mini" :show-message="false">
          <el-form-item label="账簿编号" prop="abookCode" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
            <el-input clearable v-model="sendDataInfo.abookCode" @keyup.enter.native="openSearch('336844454858752', 0, 'abookCode', 'abookCode,abookId,abookName')">
              <el-button slot="append" @click="openSearch('336844454858752', 0, 'abookCode', 'abookCode,abookId,abookName')" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="账簿名称">
            <el-input clearable v-model="sendDataInfo.abookName" disabled></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: center;margin-top:20px;">
          <el-button type="primary" plain @click="initActionBox('sendDataInfo')">取消</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        psomBuycus: "",
        coName: "",
        coId: "",
        cmName: "",
        cmId: "",
        page: 1,
        rows: 30,
        start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000, //开始上一个月
        end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1, //当天最后时间
        cmId: "",
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      sublist: [],//选中的数据
      buttonList: [],
      pageShowData: [],//总数据（检索模版、表单模版、表格模版）
      formDataList: [],//表单数据模版
      addSalesForm: [],
      seId: "",
      seWidth: "",
      seTitle: "",
      DialogVisible: false,
      seType: "",
      smId: "",
      parentSearchData: {},
      requesUrl: '',
      imgUrl: '',
      ormId: '',
      bookKeepShow: false,
      sendDataInfo: {
        abookCode: "",
        abookId: "",
        abookName: "",
        ids: []
      },
      type: "",
      sField: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.smName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.smId = "";
        }
      },
      deep: true,
    },
    bookKeepShow() {
      if (!this.bookKeepShow) {
        this.init();
      }
    },
  },
  //方法集合
  methods: {
       //获取状态
       getIsGsp(str, val) {
      try {
        str && str.replace(/\\/g, "");
        let arr = JSON.parse(str);
        let len = arr.length;
        let newStr = "";
        for (let i = 0; i < len; i++) {
          if (arr[i].key == val) {
            newStr = arr[i].value;
            break;
          }
        }
        return newStr;
      } catch (ex) {
        return str;
      }
    },
    // 动作集合
    actionSet(actionData) {
      switch (actionData.actionType) {
        case 0:
          if (this.sublist.length == 0) {
            this.$message({
              message: "请先选中要操作的数据",
              type: "error",
            });
            return
          }
          this.bookKeepShow = true
          break;
      }
    },
    handleSelectionChange(val) {
      this.sublist = val
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      console.log(orderId);
      if (orderId) {
        // 设置为true 打开穿透组件首页
        var isPenetrate = true;
        // 设置缓存 存入点击单号
        this.resetSetItem("penetrateOrderId", orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({
          //向窗口发送MessageEvent消息
          cmd: "returnFormJson",
          params: {
            isPenetrate
          }, //参数
        },
          "*"
        );
      }
    },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      this.DialogVisible = true;
      this.seId = sId;
      this.type = type
      this.sField = sField
      if (type == 'abookCode') {
        this.parentSearchData[type] = this.sendDataInfo[type]
      } else {
        this.parentSearchData[type] = this.getRequestData[type]
      }
    },
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val)
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        if (this.type == 'abookCode') {
          this.sendDataInfo[item] = val[item]
        } else {
          this.getRequestData[item] = val[item]
        }
      })
    },
    sendDataAction(sendDataInfo) {
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.subFn()
        } else {
          this.$message({
            message: '请完善必填项！',
            type: "error",
          });
          return false;
        }
      });
    },
    subFn() {
      this.$confirm("确定将选中记账吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.sub()
        })
        .catch(() => { });
    },
    async sub() {
      this.sublist.forEach(item => { this.sendDataInfo.ids.push(item.reraId) })
      let responseData = await this.$http.suRefundBookAccount(this.sendDataInfo);
      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$refs['sendDataInfo'].resetFields();
        this.bookKeepShow = false
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    //取消
    initActionBox(sendDataInfo) {
      this.$confirm("确定取消新增吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs[sendDataInfo].resetFields();
          this.bookKeepShow = false;
        })
        .catch(() => {
        });
    },
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "ids") {
          this.sendDataInfo[key] = [];
        } else {
          this.sendDataInfo[key] = "";
        }
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },

    getSearchName(e) {
      this.seTitle = e;
    },
    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path);
      let responseData = await this.$http.getJur({
        ids: [pathId.jurId]
      });
      if (responseData.status == 200) {
        this.pageShowData = responseData.result;
        this.formDataList = this.pageShowData.jurFormVoList
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList();
        this.getButtonList();
        if (this.pageShowData.jurFormVoList.length != 0) this.addSalesForm = this.pageShowData.jurFormVoList[0].jurconfigform
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    //自定义设计
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      if (this.getRequestData.cmName == "") this.getRequestData.cmId = "";
      let responseData = await this.$http.suRefundQueryAccount(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
      console.log(this.buttonList)
    },
//获取图片存取的根路径
    imgurl() {
      // console.log(this.$store.getters.getConfig);
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.imgUrl = this.$store.getters.getConfig.imgUrl;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.ormId = sessionStorage.getItem('ormId')
    this.getPageInfo();
    this.imgurl()

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}

.el-drawer {
  outline: none;
}
</style>